import React, { memo } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useStyles } from '@material-ui/pickers/views/Calendar/SlideTransition';
import moment from 'moment';
import { TextInput } from './TextInput';

function DateTimePicker({ label, value, onChange, error, disablePast, disableFuture, disabled, style }) {
  const classes = useStyles();
  return disabled ? (
    <TextInput disabled label={label} value={moment(value).format('L')} />
  ) : (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDateTimePicker
        autoOk
        label={label}
        format="dd/MM/yyyy HH:mm"
        value={value}
        InputProps={{
          readOnly: disabled,
          disableUnderline: disabled,
        }}
        InputAdornmentProps={{ position: 'end' }}
        onChange={(date, value) => onChange(date)}
        invalidDateMessage="Invalid date format"
        minDateMessage="Invalid date"
        maxDateMessage="Invalid date"
        disableFuture={disableFuture}
        disablePast={disablePast}
        className={classes.datePicker}
        error={!!error}
        helperText={error}
        style={{ margin: '16px 0px 8px', width: '-webkit-fill-available', ...style }}
      />
    </MuiPickersUtilsProvider>
  );
}

export default memo(DateTimePicker);
